import { Icon, IconColor, IconID } from '@hub/common/Icon/Icon';
import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import { Modal } from '@hub/common/Modal/Modal';
import { usePiwikPro } from '@piwikpro/next-piwik-pro';
import { IbhEventCategory, TrackedIbhEventActions } from '@hub/bearing-hub/common/tracking.config';
import type { IbhArticlePriceScalesResponseDto } from '@igus/iglidur-bearing-hub-api/src/data-contracts';

interface PriceScaleProps {
  articleNumber: string;
  partsPriceScales: IbhArticlePriceScalesResponseDto[] | undefined;
  fetchPriceScales: () => void;
  icnPriceScales?: IbhArticlePriceScalesResponseDto[] | undefined;
}

export const PriceScale = ({ articleNumber, partsPriceScales, fetchPriceScales, icnPriceScales }: PriceScaleProps) => {
  const { CustomEvent } = usePiwikPro();
  const [overlay, setOverlay] = useState(false);
  const priceScales = icnPriceScales || partsPriceScales;
  const handleOpen = () => {
    CustomEvent.trackEvent(IbhEventCategory, TrackedIbhEventActions.openQuantityDiscount);
    if (!priceScales) {
      fetchPriceScales();
    }
    setOverlay(true);
  };
  const { t } = useTranslation(['product/buyBox', 'layout/general']);

  return (
    <>
      <button type="button" onClick={handleOpen} className="cursor-pointer" data-testid="price_scale_modal_open">
        <Icon size={4} color={IconColor.ORANGE} id={IconID.ARROW_RIGHT} primary={false} />
        <span className="ml-4">{t('BUY_BOX.QUANTITY_DISCOUNT')}</span>
      </button>
      <Modal
        visible={overlay}
        onClose={() => setOverlay(false)}
        headline={`${t('BUY_BOX.SCALE_PRICES_TITLE')} ${articleNumber.replace('TEMP-', '') || ''}`}
      >
        {priceScales && !!priceScales?.length && (
          <table className="w-full font-light">
            <tbody className="bg-gray-50 border-gray-200 font-light text-xs">
              {priceScales.length &&
                priceScales.map(scale => (
                  <tr key={scale?.priceText}>
                    <td className="border px-4 py-2">{scale?.quantityText}</td>
                    <td className="border px-4 py-2">{scale?.priceText}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}
      </Modal>
    </>
  );
};
